module.exports = __webpack_public_path__ + "img/default-user-banner.a7207270.png";